export default __webpack_public_path__ + "static/media/channelIcon.a2effe99.png";